var React = require('react');

function ListViewInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 4H8M4 4H3m18 8H8m-4 0H3m18 8H8m-4 0H3","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

ListViewInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ListViewInline;

ListViewInline.default = ListViewInline;
